<template>
  <div class="menu-title" @click="onLogoClick">
    <div class="logo-title-box">
      <div :class="'layout-title'">
        <div class="title-content first-title">{{ g_Config.TITLE }}</div>
        <!-- <div class="title-content second-title">{{ g_Config.DESCRIPTION }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuTitle',
  props: {
    isDark: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  methods: {
    onLogoClick() {
      this.$router.push('home')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'menu-title',
  (
    --menu-title-first-title: #fff,
    --menu-title-second-title: #a3afb5
  ),
  (
    --menu-title-first-title: #303333,
    --menu-title-second-title: #a3afb5
  )
);

.menu-title {
  @include adaptation(
    (
      --menu-title-height: 95px,
      --menu-title-logo-size: 40px,
      --menu-title-logo-margin-left: 16px,
      --menu-title-margin-left: 4px,
      --menu-title-first-title-font-size: 18px,
      --menu-title-second-title-font-size: 12px,
      --menu-title-second-title-margin-left: 2px
    )
  );
  overflow: hidden;
  height: var(--menu-title-height);
  display: flex;

  .logo-title-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .layout-logo {
      width: var(--menu-title-logo-size);
      height: auto;
      margin-left: var(--menu-title-logo-margin-left);
    }

    .layout-title {
      flex: 1;
      line-height: 1;
      word-break: break-word;
      margin-left: var(--menu-title-margin-left);

      .title-content.first-title {
        color: var(--menu-title-first-title);
        font-size: var(--menu-title-first-title-font-size);
        font-style: normal;
        line-height: normal;
        text-align: center;
      }

      .title-content.second-title {
        color: var(--menu-title-second-title);
        font-size: var(--menu-title-second-title-font-size);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: var(--menu-title-second-title-margin-left);
      }
    }
  }
}
</style>
